import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import NgpTextField from '../../../../form/NgpTextField';
import { AUTO_COMPLETE_DEFAULT } from '../../../../../utilities/FormUtilities';
import NgpPasswordField from '../../../../form/NgpPasswordField';

/**
 * Shared username + password credential fields for HTTP auth modes (BASIC, NTLM).
 * Renders inside a react-hook-form FormProvider context.
 *
 * @param {Object} props
 * @param {string} props.fieldPrefix - RHF field path prefix (e.g. "testConfig.auth.basic")
 */
const AuthCredentialsFields = ({ fieldPrefix }) => (
    <>
        <div style={{ width: 450 }}>
            <NgpTextField
                fieldName={`${fieldPrefix}.username.value`}
                label={t`Username`}
                required
                inputProps={{ size: 60, maxLength: 2083, autoComplete: AUTO_COMPLETE_DEFAULT }}
            />
        </div>
        <div style={{ width: 450 }}>
            <NgpPasswordField
                fieldName={`${fieldPrefix}.password.value`}
                label={t`Password`}
                inputProps={{ size: 60, maxLength: 2083 }}
                required
                togglePasswordVisibility
            />
        </div>
    </>
);

AuthCredentialsFields.propTypes = {
    fieldPrefix: PropTypes.string.isRequired,
};

export default AuthCredentialsFields;
